<script>
    // import { createEventDispatcher } from "svelte";
    import { fly, fade, scale } from 'svelte/transition'
    export let node = ''
    export let show = false
    let _show = false
    export let color = '#999'
    import {afterUpdate} from 'svelte'

    const uuid = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    );    

    let okID = uuid()
    let cancelID = uuid()
    let focus = false

    afterUpdate(() =>{
        if (!focus) {
            try {
                if (showCancel) {
                    document.getElementById(cancelID).focus()
                    focus = true
                } else {
                    document.getElementById(okID).focus()
                    focus = true
                }
            } catch(e) {}
        }
    })

    $: if (color !== '#999') {

        // console.log(color);
        document.documentElement.style.setProperty(
            '--mb-colordark20',
            // LightenDarkenColor(color, -66)
            hexToHSL(color, -0.3)
        )
        document.documentElement.style.setProperty(
            '--mb-colordark10',
            // LightenDarkenColor(color, -33)
            hexToHSL(color, -0.1)
        )
        document.documentElement.style.setProperty('--mb-color', color)
        document.documentElement.style.setProperty(
            '--mb-colorlight10',
            // LightenDarkenColor(color, 33)
            hexToHSL(color, 0.1)
        )
        document.documentElement.style.setProperty(
            '--mb-colorlight20',
            // LightenDarkenColor(color, 66)
            hexToHSL(color, 0.3)
        )
    } else {
        document.documentElement.style.setProperty('--mb-colordark20', '#666')
        document.documentElement.style.setProperty('--mb-colordark10', '#777')
        document.documentElement.style.setProperty('--mb-color', '#999')
        document.documentElement.style.setProperty('--mb-colorlight10', '#ccc')
        document.documentElement.style.setProperty('--mb-colorlight20', '#eee')
    }
    let Msg = ''
    let Title = ''
    let showok = false
    let showCancel = false
    let okf = null
    let nof = ()=>{}
    let txtclose = 'Cancel'
    let txtok = 'OK'
    let style = ''
    let inputmode = false
    let inputline
    let inpval = ''
    let inpplaceholder = ''
    let multline = false
    let modaldiv
    let md = false
    let allowmmove = false
    let mi = null
    let minheight = 180
    let minwidth = 300
    export function Ok(message, title, okfunc) {
        Msg = message
        Title = title
        style = 'background-color: white;'
        showok = true
        txtok = 'OK'
        okf = okfunc
    }
    export function OkCancel(message, title, okfunc) {
        Msg = message
        Title = title
        showok = true
        showCancel = true
        okf = okfunc
    }
    export function YesNo(message, title, okfunc, nofunc) {
        Msg = message
        Title = title
        showok = true
        showCancel = true
        txtclose = 'No'
        txtok = 'Yes'
        okf = okfunc
        nof = nofunc
    }
    export function Input(initial, title, placeholder, multiline, okfunc) {
        inputmode = true
        inpval = initial
        inpplaceholder = placeholder
        multline = multiline
        Title = title
        showok = true
        minheight = 346
        okf = okfunc
    }
    function close() {
        show = false
        setTimeout(() => {
            document.body.removeChild(node)
        }, 1000)
    }
    function okclick(e) {
        e.preventDefault()
        if (okf) {
            if (inputmode) {
                if (inpval !== '') {
                    okf(inpval)
                    close()
                    return
                } else return
            }
            okf()
        }
        close()
    }
    function noclick(e){
        e.preventDefault()
        if (nof) {
            if (inputmode) {
                if (inpval !== '') {
                    nof(inpval)
                    close()
                    return
                } else return
            }
            nof()
        }
        close()
    }
</script>


<svelte:options accessors={true} />

{#if show}
    <dialog style="z-index:1002" class="modal active" open="">
        <div class="center-align">
            <h3>{Title}</h3>
        </div>
        {#if inputmode}
            {#if multline}
                <textarea
                    id="msgboxTextArea"                    
                    rows="10"
                    placeholder={inpplaceholder}
                    bind:value={inpval}>
                </textarea>
            {:else}
                <input
                    placeholder={inpplaceholder}
                    bind:value={inpval} />
            {/if}
        {:else}
            <div class="center-align">
                <label for="msgboxTextArea"><h5>{Msg}</h5></label>
            </div>
            {/if}
        <nav class="right-align no-space">
            {#if showok}
                <button on:click={okclick}>{txtok}</button>
            {/if}
            {#if showCancel}
                <button on:click={noclick}>{txtclose}</button>
            {/if}
            </nav>
    </dialog>

{/if}

 <!--    <div transition:fade class="modal-backdrop" />
    <div
        transition:scale={{ y: 300, duration: 200 }}
        class="modal"
        {style}
        on:mousedown={mdown}
        bind:this={modaldiv}>
        <h1 on:focus={()=>{}} on:mouseover={() => (allowmmove = true)}>{Title}</h1>
        <div class="content">
            {#if inputmode}
                {#if multline}
                    <textarea
                        id="msgboxTextArea"                    
                        class="txt"
                        rows="10"
                        placeholder={inpplaceholder}
                        bind:value={inpval} />
                {:else}
                    <input
                        class="txt"
                        placeholder={inpplaceholder}
                        bind:value={inpval} />
                {/if}
            {:else}
                <label for="msgboxTextArea" class="msg">{Msg}</label>
            {/if}
        </div>
        <footer>
            <div>
                <slot name="footer">
                <form>
                    {#if showok}
                        <div class="ok">
                            <button id="{okID}" on:click={okclick}>{txtok}</button>
                        </div>
                    {/if}
                    {#if showCancel}
                        <button id="{cancelID}" class="outline" on:click={noclick}>{txtclose}</button>
                    {/if}
                </form>    
                </slot>
            </div>
        </footer>
        {#if inputmode}
            <div class="resizer" on:mousedown={rdown} />
        {/if}
    </div>
 -->